/* tslint:disable */
/* eslint-disable */
/**
 * P4m.Module.Auth.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimsIdentity } from './ClaimsIdentity';
import {
    ClaimsIdentityFromJSON,
    ClaimsIdentityFromJSONTyped,
    ClaimsIdentityToJSON,
    ClaimsIdentityToJSONTyped,
} from './ClaimsIdentity';

/**
 * 
 * @export
 * @interface Claim
 */
export interface Claim {
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    readonly issuer?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    readonly originalIssuer?: string | null;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof Claim
     */
    readonly properties?: { [key: string]: string; } | null;
    /**
     * 
     * @type {ClaimsIdentity}
     * @memberof Claim
     */
    subject?: ClaimsIdentity;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    readonly type?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    readonly value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Claim
     */
    readonly valueType?: string | null;
}

/**
 * Check if a given object implements the Claim interface.
 */
export function instanceOfClaim(value: object): value is Claim {
    return true;
}

export function ClaimFromJSON(json: any): Claim {
    return ClaimFromJSONTyped(json, false);
}

export function ClaimFromJSONTyped(json: any, ignoreDiscriminator: boolean): Claim {
    if (json == null) {
        return json;
    }
    return {
        
        'issuer': json['issuer'] == null ? undefined : json['issuer'],
        'originalIssuer': json['originalIssuer'] == null ? undefined : json['originalIssuer'],
        'properties': json['properties'] == null ? undefined : json['properties'],
        'subject': json['subject'] == null ? undefined : ClaimsIdentityFromJSON(json['subject']),
        'type': json['type'] == null ? undefined : json['type'],
        'value': json['value'] == null ? undefined : json['value'],
        'valueType': json['valueType'] == null ? undefined : json['valueType'],
    };
}

export function ClaimToJSON(json: any): Claim {
    return ClaimToJSONTyped(json, false);
}

export function ClaimToJSONTyped(value?: Omit<Claim, 'issuer'|'originalIssuer'|'properties'|'type'|'value'|'valueType'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'subject': ClaimsIdentityToJSON(value['subject']),
    };
}

